import { useNavigate } from "react-router-dom";
import { defineGoBack } from "../utils/defineGoBack";

export default function (path?: string): () => void {
    const navigate = useNavigate();

    return () => {
        if (path) navigate(path, { replace: true });
        //Verify not leaving the site
        else if (defineGoBack()) navigate("/", { replace: true });
        else navigate(-1);
    };
}
